import { inject, Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ConnectionStatus, Network } from '@capacitor/network';

@Injectable({
  providedIn: 'root',
})
export class NetworkService {
  #online$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(navigator.onLine);
  #zone: NgZone = inject(NgZone);

  get online$(): Observable<boolean> {
    return this.#online$.asObservable();
  }

  constructor() {
    void this.#initNetworkStatus();
  }

  #updateOnlineStatus = (isOnline: boolean): void => {
    this.#online$.next(isOnline);
  };

  async #initNetworkStatus(): Promise<void> {
    const status: ConnectionStatus = await Network.getStatus();
    this.#updateOnlineStatus(status.connected);

    await Network.addListener('networkStatusChange', (status: ConnectionStatus) => {
      this.#zone.run(() => {
        this.#updateOnlineStatus(status.connected);
      });
    });
  }
}
